import { RootState } from 'duck/store'
import { connect } from 'react-redux'
import { getDeal } from 'scenes/Dashboard/data/deals/selectors'
import { getOrganization } from 'scenes/Dashboard/data/organizations/selectors'

import { hideOrganizationDetails } from './duck/actions'
import { getOrganizationDetailsModalState } from './duck/selectors'
import OrganizationDetailsModal, { OrganizationDetailsModalProps } from './OrganizationDetailsModal.presentational'

function mapStateToProps(state: RootState, { footer }: ContainerProps): StateProps {
  const { show, isInEditMode, dealId, organizationId, isLoading, isSubmitting } = getOrganizationDetailsModalState(
    state
  )
  const deal = getDeal(state, dealId || undefined)
  // const user = getUser(state, deal?.corporateId)
  const user = undefined
  const organization = getOrganization(state, organizationId || undefined)

  return {
    show,
    isInEditMode,
    isSubmitting,
    isLoading,
    deal,
    user,
    organization,
    footer,
  }
}

type StateProps = Pick<
  OrganizationDetailsModalProps,
  'show' | 'isInEditMode' | 'isSubmitting' | 'isLoading' | 'deal' | 'user' | 'organization' | 'footer'
>

type DispatchProps = Pick<OrganizationDetailsModalProps, 'onClose'>

type ContainerProps = Pick<OrganizationDetailsModalProps, 'footer'>

export default connect(mapStateToProps, {
  onClose: hideOrganizationDetails,
} as DispatchProps)(OrganizationDetailsModal)
